var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _g2, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShouldersG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 181,
    viewBox: "0 0 212 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1983 6.24051C71.4211 5.42391 73.0468 5.41437 74.9792 5.91205C75.92 18.3251 87.6608 24.9855 106.087 24.9855C124.32 24.9855 136.105 18.4666 137.271 6.30478C138.431 5.70594 141.514 5.38434 142.788 6.65365C142.788 6.65688 142.788 6.66011 142.788 6.66333C151.325 9.44453 159.891 12.3769 167.256 14.898L167.256 14.8981C170.616 16.0483 173.726 17.1129 176.469 18.0384C192.386 23.4098 201.958 68.1348 205.639 99.0194C201.152 103.512 188.812 109.058 164.671 109.058C164.671 111.289 164.614 127.914 164.556 144.648L164.555 144.782L164.555 144.816C164.497 161.729 164.438 178.706 164.438 181H106H105.999H47.7214C47.7214 178.704 47.6089 161.811 47.4969 144.99C47.3859 128.313 47.2753 111.708 47.2753 109.472C23.1348 109.472 10.8473 103.512 6.36035 99.0194C10.0419 68.1348 19.6132 23.4098 35.5311 18.0384C38.2739 17.1129 41.3837 16.0483 44.7436 14.8981L44.744 14.898L44.7442 14.8979C52.3925 12.2797 61.3367 9.21775 70.1985 6.34234C70.1983 6.30842 70.1983 6.27448 70.1983 6.24051Z",
    fill: "#191919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0655 20.8486C16.7854 32.3761 8.64167 71.2811 5.2998 99.0208C9.55 103.705 23.1145 110.039 47.3142 110.094C46.7151 87.9577 46.5234 54.237 48.194 51.2714L48.2107 51.2421C47.2357 43.3839 40.8548 34.0318 35.3043 26.823C33.4772 24.45 31.6051 22.6885 30.0655 20.8486Z",
    fill: "#191919"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6297 119.723V120.263H47.6517C47.6443 120.085 47.637 119.905 47.6297 119.723Z",
    fill: "#191919"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.627 20.6211C195.191 31.3709 203.522 70.6401 206.864 98.3798C202.614 103.064 189.05 109.398 164.85 109.453C165.449 87.3167 165.641 53.5961 163.97 50.6304L163.953 50.6011C164.928 42.7429 171.309 33.3908 176.86 26.182C178.687 23.8091 180.088 22.4609 181.627 20.6211Z",
    fill: "#191919"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164.534 119.082V119.622H164.512C164.52 119.444 164.527 119.264 164.534 119.082Z",
    fill: "#191919"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3992 17.4134C45.1352 14.0554 56.7292 9.89503 70.0251 5.86958C71.0204 5.55888 73.5897 4.9855 75.3869 5.86957C75.7993 13.2898 80.9194 18.927 87.5185 21.8127C78.9625 26.5884 59.1135 39.0725 48.1656 50.8031C46.4884 43.2551 36.5357 27.9233 29.7764 20.9753C31.5217 19.2272 33.4329 18.0916 35.3992 17.4134Z",
    fill: "#9A9A9A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176.612 17.413C166.876 14.055 155.282 9.89468 141.986 5.86924C141.115 5.56837 138.632 5.06438 136.624 5.86922C136.211 13.2894 131.091 18.9267 124.492 21.8123C133.048 26.588 152.897 39.0722 163.845 50.8028C165.522 43.2547 175.475 27.923 182.234 20.9749C180.489 19.2269 178.578 18.0912 176.612 17.413Z",
    fill: "#9A9A9A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3291 110.636C23.1679 110.636 9.52239 104.121 5.03165 99.5916C4.62268 97.5243 5.06578 93.4461 6.11632 91.2666C11.8298 96.2857 29.063 100.636 47.0689 101.155L47.3291 110.636Z",
    fill: "#191919"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M164.649 109.928C189.005 109.928 202.175 104.909 206.702 100.38C207.527 98.7231 207.114 93.3379 205.876 91.2666C200.116 96.2857 183.213 100.726 165.062 101.245L164.649 109.928Z",
    fill: "#191919"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_564_13635",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 5,
    width: 59,
    height: 46
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M176.612 17.413C166.876 14.055 155.282 9.89468 141.986 5.86924C141.115 5.56837 138.632 5.06438 136.624 5.86922C136.211 13.2894 131.091 18.9267 124.492 21.8123C133.048 26.588 152.897 39.0722 163.845 50.8028C165.522 43.2547 175.475 27.923 182.234 20.9749C180.489 19.2269 178.578 18.0912 176.612 17.413Z",
    fill: "#D3D3D3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_564_13635)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.4835,
    height: 79.3192,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 124.176 -18.9668)",
    fill: "#464646"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_564_13635",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 5,
    width: 59,
    height: 46
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3992 17.4134C45.1352 14.0554 56.7292 9.89503 70.0251 5.86958C71.0204 5.55888 73.5897 4.9855 75.3869 5.86957C75.7993 13.2898 80.9194 18.927 87.5185 21.8127C78.9625 26.5884 59.1135 39.0725 48.1656 50.8031C46.4884 43.2551 36.5357 27.9233 29.7764 20.9753C31.5217 19.2272 33.4329 18.0916 35.3992 17.4134Z",
    fill: "#D3D3D3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_564_13635)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.0938,
    y: -10.8242,
    width: 24.8578,
    height: 79.3192,
    transform: "rotate(60 70.0938 -10.8242)",
    fill: "#464646"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.0377 5.68649C73.2072 4.9969 69.7369 5.54658 68.5479 6.29874C68.5479 21.4718 84.0614 31.6134 105.778 31.6134C127.494 31.6134 142.835 21.6395 142.835 6.46648C141.582 5.21832 137.528 5.09831 136.125 5.59944C135.196 17.8165 123.781 24.3697 106.026 24.3697C88.3129 24.3697 77.007 17.8465 76.0377 5.68649Z",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShouldersG);
export default __webpack_public_path__ + "static/media/Shoulders G.b702a1892f2500be54a66abe1c706db2.svg";
export { ForwardRef as ReactComponent };